import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=38f7df21&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"
import style0 from "./portfolio.vue?vue&type=style&index=0&id=38f7df21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7df21",
  null
  
)

export default component.exports